import moment from "moment";
import emailValidator from "email-validator";
import { messages } from "@/helpers/locales/locales";
// import parsePhoneNumber from 'libphonenumber-js/mobile'
// const libphonenumber = () => import("libphonenumber-js/mobile");
// let parsePhoneNumber = undefined;

export default {
    validate(rule, formField, validate, callback, setFormValidation) {
        const value = formField.value;
        const formName = formField.formName;
        const validateRule = validate.rule || validate;
        const validateOptions = validate.options || null;

        if (formField.errors) {
            let errorMassage = formField.errors;
            formField.errors = null;
            setFormValidation(formName, rule.field, false);
            if (typeof errorMassage == "string") {
                callback(new Error(errorMassage));
            } else if (errorMassage instanceof Array) {
                callback(new Error(errorMassage[0]));
            } else {
                callback(new Error("Error field: " + rule.field));
            }
            return false;
        }

        let validationResult = true;

        if (validate) {
            if (!this[validateRule + "Validate"]) {
                return false;
            }
            validationResult = this[validateRule + "Validate"](
                value,
                validateOptions,
                formField
            );
        }

        if (validationResult == true) {
            if (callback) {
                setFormValidation(formName, rule.field, true);
                callback();
            } else {
                return true;
            }
        } else {
            if (callback) {
                setFormValidation(formName, rule.field, false);
                callback(new Error(validationResult));
            } else {
                return validationResult;
            }
        }
        // this.validationResult(this[validateRule + 'Validate'](value, validateOptions, formField), formName, rule, callback, setFormValidation);
    },

    validationResult(result, formName, rule, callback, setFormValidation) {
        if (result == true) {
            if (callback) {
                setFormValidation(formName, rule.field, true);
                callback();
            } else {
                return true;
            }
        } else {
            if (callback) {
                setFormValidation(formName, rule.field, false);
                callback(new Error(result));
            } else {
                return new Error(result);
            }
        }
    },

    // passwordValidate(value) {
    //     if (!value) {
    //         return 'Please input Name';
    //     } else {
    //         return true;
    //     }
    // },

    // passwordConfirmValidate(value) {
    //     if (!value) {
    //         return 'Please input Name';
    //     } else {
    //         return true;
    //     }
    // },
    pharmacyNameValidate(value) {
        if (!value) {
            return "Please input Pharmacy Name";
        } else {
            return true;
        }
    },
    additionalDataValidate(value) {
        if (!value) {
            return "Please sub type";
        } else {
            return true;
        }
    },
    additionalName1Validate(value) {
        if (!value) {
            // return "Please input Contact Name";
            return true;
        } else {
            return true;
        }
    },
    additionalName2Validate() {
        return true;
    },
    employerAdditionalNameValidate(value) {
        if (!value) {
            return "Please input Contact Name";
        } else {
            return true;
        }
    },

    nameValidate(value) {
        if (!value) {
            return "Please input Name";
        } else {
            return true;
        }
    },
    pharmacyLicenseValidate(value) {
        console.log("🚀 ~ pharmacyLicenseValidate ~ value:", value)
        if (!value) {
            return "Please input License Number";
        } else {
            return true;
        }
    },
    genderValidate(value) {
        if (value !== null) {
            return true
        }
        else {
            return 'Please select your gender'
        }
    },    
    otherGenderValidate(value){
        if (value !== '') {
            return true
        }
        else {
            return 'Please input your gender'
        }
    },
    taxNumberValidate(value) {
        if (!value) {
            return 'Please input your tax file number'
        }
        else {
            return true
        }
    },
    billingTypeValidate(value) {
        if (!value) {
            return "Please choose your entity"
        }
        else {
            return true
        }
    },
    emergencyContactNameValidate(value) {
        if (!value.trim()) {
            return "Please enter Emergency Contact Name";
        } else {
            return true;
        }
    },
    emergencyFirstNameValidate() {
        return true;
    },
    emergencyLastNameValidate() {
        return true;
    },
    emergencyMobileNumberValidate() {
        return true;
    },
    emergencyRelationshipValidate(value) {
        if (!value) {
            return "Please enter your Relationship";
        } else {
            return true;
        }
    },
    businessNameValidate(value) {
        if(value){
            if (/^(?!\s*$).+/.test(value)) {
                return true;
            } else {
                return "Please input valid Business Name";
               
            }
        }else{
            return "Please input Business Name";
        }
       
    },

    bankAccountNameValidate(value) {
        if (!value) {
            return "Please input Account Name";
        } else {
            return true;
        }
    },
    bankNameValidate(value) {
        if (!value) {
            return "Please select bank";
        } else {
            return true;
        }
       
    },
    accountTypeValidate() {
            return true;
    },
    fundTypeValidate(value) {
        if (value === null) return 'Please choose your Fund Type' 
        else return true
    },
    titleValidate(value) {
        if (!value) {
            return 'Please select a title';
        }
        return true;
    },
    firstNameValidate(value) {
        if (!value.trim()) {
            return "Please enter your First Name";
        } else {
            return true;
        }
    },

    lastNameValidate(value) {
        if (!value.trim()) {
            return "Please enter your Last Name";
        } else {
            return true;
        }
    },
    preferredNameValidate() {
        return true;
    },
    usiValidate(value) {
        if (!value) {
            return 'Please input USI'
        }
        else {
            return true
        }
    },
    anyNumberValidate(value) {
        if (value) {
            return true
            
        }
        else {
            return 'Please input number'
        }
    },
    bpayNumberValidate() {
        return true;
    },
    customerRefNumberValidate() {
        return true;
    },

    mobileNumberValidate(value) {
        if (!value) {
            return "Please input mobile number";
        } else if (value.lenght < 8 || value.lenght > 15) {
            return "Please input correct mobile number";
        }else if (/[a-zA-Z]/.test(value)) {
            return "Mobile number cannot contain letters";
        }  else {
            return true;
        }
    },
    employerMobileNumberValidate(value) {
        console.log("🚀 ~ employerMobileNumberValidate ~ value:", value)
        if (!value && value == null) {
            return "Please input mobile number";
        } else if (value.lenght < 8 || value.lenght > 15) {
            return "Please input correct mobile number";
        }else if (/[a-zA-Z]/.test(value)) {
            return "Mobile number cannot contain letters";
        }  else {
            return true;
        }
    },
    additionalPhone1Validate() {
        // var required = /^\+[0-9]$/g;
        // const a =  required.test(String(value).toLowerCase());

        return true;
        // return "Please input Mobile number";
    },
    additionalPhone2Validate() {
        // var required = /^\+[0-9]$/g;
        // const a =  required.test(String(value).toLowerCase());

        return true;
    },

    emailValidate(value) {
        if (!value) {
            return " You need to enter your email to continue";
        } else if (!emailValidator.validate(value)) {
            return "Please provide a valid email to continue";
        } else {
            return true;
        }
    },
    additionalEmail1Validate(value){
        if (!value) {
            return " You need to enter your email to continue";
        } else if (!emailValidator.validate(value)) {
            return "Please provide a valid email to continue";
        } else {
            return true;
        }
    },
    preferredEmailsValidate(value) {
     
        if (value) {
            var emails = value.replace(/\s/g,'').split(",");
       
            //eslint-disable-next-line
            var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            for (var i = 0; i < emails.length; i++) {
                if( emails[i] == "" || ! regex.test(emails[i])){
                    return "emails provided is incorrected. Please verify first"
                }
            }
            return true;
        } else {
            return "please enter emails of preferred locums";
        }
    },
    guestEmailsValidate(value) {
        const region = process.env.VUE_APP_REGION || 'AU';
        const message = messages[region];
        if (value) {
            var emails = value.replace(/\s/g,'').split(",");
       
            //eslint-disable-next-line
            var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            for (var i = 0; i < emails.length; i++) {
                if( emails[i] == "" || ! regex.test(emails[i])){
                    return "emails provided is incorrect. Please verify first"
                }
            }
            return true;
        } else {
            return `please enter emails of guest ${message.locum}(s)`;
        }
    },
    additionalEmailValidate() {
        return true
    },
    addressValidate(value) {
        if (!value.text) {
            return "Please select your address";
        } else {
            return true;
        }
    },
    seekerAddressValidate(value) {
        if (!value.text) {
            return "Select your City and State";
        } else {
            return true;
        }
    },
    billingAddressValidate(value) {
        if (value) {
            return true
        }
        else {
            return "Please select address from dropdown"
        }
    },

    confirmNumbersValidate(value, options, formField) {
        if (value == null) {
            return "Please input confirm code";
        } else if (value.length < formField.numberLength) {
            return "Please input all numbers";
        } else {
            return true;
        }
    },

    birthdayValidate(value) {
        console.log("🚀 ~ birthdayValidate ~ value:", value);
    
        if (!value) {
            return "Please select Date of Birth";
        }
    
        const selectedDate = new Date(value);
        const today = new Date();
        
        // Calculate the date that is exactly 18 years ago from today
        const eighteenYearsAgo = new Date();
        eighteenYearsAgo.setFullYear(today.getFullYear() - 18);

        // Calculate the date that is exactly 100 years ago from today
        const maxAgeDate = new Date();
        maxAgeDate.setFullYear(today.getFullYear() - 100);
    
        // Check if the selected date is before or exactly the 18 years ago date
        if (selectedDate > today) {
            return "Date of Birth cannot be in the future.";
        }
    
        if (selectedDate > eighteenYearsAgo) {
            return "You must be at least 18 years old.";
        }
        if (selectedDate < maxAgeDate) {
            return "Please enter a valid Date of Birth within the past 100 years.";
        }
    
        return true;
    },

    abnCheck(value) {
        let weights = new Array(10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19);
        let abn = value.replace(/\D/g, "");
        if (abn.length != 11) {
            return false;
        }
        let abnFirstDigit = parseInt(abn.charAt(0)) - 1;
        abn = abnFirstDigit + abn.substring(1);

        let total = 0;
        for (let i = 0; i < 11; i++) total += weights[i] * abn.charAt(i);

        if (total == 0 || total % 89 != 0) {
            return false;
        } else {
            return true;
        }
    },

    licenseTextValidate(value){
        if (!/^[a-zA-Z]{3}$/.test(value)) {
            return "Please enter a valid three-letter word";
          } else if (!value) {
            console.log('value is empty')
            return "Please input license text";
        } else {
            return true;
        }
    },
    licenseNumberValidate(value){
        if (!/^\d{5}$/.test(value)) {
            return 'Please enter a valid five-digit number';
          } else if (!value) {
            console.log('value is empty')
            return "Please input license number";
        } else {
            return true;
        }
    },
    eprofileidValidate(value){
        if (!/^\d{6,9}$/.test(value)) {
            return 'Please enter a valid number between 6 and 9 digits';
          } else if (!value) {
            console.log('value is empty')
            return "Please input eProfile number";
        } else {
            return true;
        }
    },

    abnValidate(value) {
       
        if (/^(\d *?){11}$/.test(value)) {
            console.log('hello', value);
            if (this.abnCheck(value)) {
                console.log('abn true', value);
                return true;
            } else {
                console.log('abn value false', value);
                return "ABN is not valid";
            }
        } else if (!value) {
            console.log('value is empty')
            return "Please input ABN";
        } else {
            return "ABN is not valid";
        }
    },

    ahpraExpiryDateValidate(value) {
       
        if (!value) {
            if (process.env.VUE_APP_REGION == 'US') {
                return "Please provide your License expiry date";
            }
            return "Please provide your AHPRA expiration date";
        } else {
            
            if (moment(value, "YYYY-MM-DD") < new Date()) {
                console.log("🚀 ~ ahpraExpiryDateValidatessssss ~ value:", value)
                return "Expiration Date must be greater than now";
            } else {

                return true;
            }
        }
    },
    ahpraExpiryDateIeValidate(value){
        if (!value) {
            return true;
        } else {
            
            if (moment(value, "YYYY-MM-DD") < new Date()) {
                return "Expiration Date must be greater than now";
            } else {

                return true;
            }
        }
    },
    nabpGuestExpiryDateValidate(value) {
        if (!value) {
            if (process.env.VUE_APP_REGION == 'US') {
                return "Please provide your NABP e-Profile expiry Date";
            }
            return "Please provide your NABP e-Profile expiry Date";
        } else {
            if (moment(value, "YYYY-MM-DD") < new Date()) {
                return "Expiration Date must be greater than now";
            } else {

                return true;
            }
        }
    },
    platformRoleValidate(value) {
        if (!value) {
            return "Please select platform role";
        } else {
            

                return true;
        }
    },
    covidCertTrueValidate() {
        return true;
    },
    travelPreferenceValidate() {
        return true;
    },
    vaccinationDateValidate(value) {
      
        if (!value.firstDate ) {
            return "Please input Vaccination Date";
        }else if( moment(value.firstDate, "YYYY-MM-DD") >= new Date()){
            
            return "Date cannot be later than today";
        }else if (
            moment(value.firstDate, "YYYY-MM-DD") >= new Date() ||
            moment(value.secondDate, "YYYY-MM-DD") >= new Date()
        ) {
            return "Date cannot be later than today";
        } else if (
            moment(value.firstDate, "YYYY-MM-DD") >=
            moment(value.secondDate, "YYYY-MM-DD")
        ) {
            return "Second date must be later than first date";
        } else {
            return true;
        }
    },
    filterDateValidate(value) {
        if (!value.fromDate && !value.toDate) {
            return "From Date and To Date cannot be empty";
        }else if (!value.fromDate) {
            return "From Date cannot be empty";
        }else if(!value.toDate){
            return "To Date cannot be empty";
        } else if (
            moment(value.fromDate, "YYYY-MM-DD") >
            moment(value.toDate, "YYYY-MM-DD")
        ) {
            return "To date must be later than From date";
        } else {
            return true;
        }
    },
    proofExpiryDateValidate(value) {
        if (!value) {
            return "Please input policy expiry Date";
        }else if( moment(value, "YYYY-MM-DD") <= new Date()){
            return "Please choose a date that is in the future";
        } else {
            return true;
        }
    },
    licenseExpiryDateValidate(value) {
        if (!value) {
            return "Please provide license expiration date";
        }else if( moment(value, "YYYY-MM-DD") <= new Date()){
            return "Please choose a date that is in the future";
        } else {
            return true;
        }
    },
    nabpExpiryDateValidate(value) {
        if (!value) {
            return "Please input NABP e-Profile expiry Date";
        }else if( moment(value, "YYYY-MM-DD") <= new Date()){
            return "Please choose a date that is in the future";
        } else {
            return true;
        }
    },
    otherExpiryDateValidate(value) {
        if (!value) {
            return "Please input policy expiry Date";
        }else if( moment(value, "YYYY-MM-DD") <= new Date()){
            return "Please choose a date that is in the future";
        } else {
            return true;
        }
    },

    ahpraValidate(value) {
        if (/[a-zA-Z]{3}\s\d{10}/g.test(value)) {
            return true;
        } else if (!value) {
            return "Please enter your AHPRA registration number";
        } else {
            return "AHPRA Registration number is not valid";
        }
    },
    ahpraIeValidate(value) {
        if (/[a-zA-Z]{3}\s\d{10}/g.test(value)) {
            return true;
        } else if (!value) {
            return true;
        } else {
            return "AHPRA Registration number is not valid";
        }
    },

    bsbValidate(value) {
        if (/\d{6}/g.test(value)) {
            return true;
        }else {
            return "BSB is not valid";
        }
    },

    bsbSuperValidate(value) {
        if (/\d{6}/g.test(value)) {
            return true;
        } else if (!value) {
            return "Please input BSB";
        } else {
            return "BSB is not valid";
        }
    },

    maxTravelAmountValidate(value){
        console.log("max value rate is here",value);
        if (value) {
            if (/^(?!0*(\.0+)?$)(?!0\d)\d*(\.\d{1,2})?$/.test(value)) {
                return true
            } else {
                return "Only two digits are accepted after decimal"
            }
           
        }  else {
            return "Please input capped travel amount";
        }
        
    },

    parkingInfoValidate(value){
        console.log("pppp rate is here",value);
        if (value) {
                return true
        }  else {
            return "Please input capped travel amount";
        }
        
    },

    bankAccountNumberValidate(value) {
        if (/\d{6,9}/g.test(value)) {
            return true;
        } else {
            return "Account Number is not valid";
        }
    },

    depositAmountValidate(value) {
        if (/^(?!0\.00$)(0\.(?!0+$)\d+|[1-4]?\d(\.\d+)?|50(\.0+)?)$/.test(value)) {
            return true;
        } else {
            return "The amount cannot be less or equal to 0";
        }
    },

    shiftDateValidate(value) {
        if (!value) {
            return "Please input Date";
        }  else {
            return true;
        }
    },

    minDateValidate(value, options) {
        let start = moment(value, "DD/MM/YYYY");
        let end = moment(options.minDate, "DD/MM/YYYY");
        if (!value) {
            return "Please input Date";
        } else if (!moment(value, "DD/MM/YYYY", true).isValid()) {
            return "Date is not valid";
        } else if (start.diff(end, "days") < 0) {
            return "Date must be later than " + options.minDate;
        } else {
            return true;
        }
    },

    timeRangeValidate(value) {
        if (!value) {
            return "Please select Time";
        } else if (!moment(value.timeStart, moment.ISO_8601, true).isValid()) {
            return "Start Time is not valid";
        } else if (!moment(value.timeEnd, moment.ISO_8601, true).isValid()) {
            return "End Time is not valid";
        } else if (
            moment(value.timeEnd, moment.ISO_8601).format('HH:mm:ss') !== '00:00:00' && // ignore validation if midnight
            moment(value.timeStart, moment.ISO_8601).diff(
                moment(value.timeEnd, moment.ISO_8601),
                "minutes"
            ) >= 0
        ) {
            return "Start Time must be earlier than End Time";
        } else {
            return true;
        }
    },

    currentTimeLaterValidate(value) {
        if (
            moment(value.date, "DD/MM/YYYY").isSame(moment(), "day") &&
            moment(value.timeStart, moment.ISO_8601).diff(moment(), "minutes") <= 0
        ) {
            return "Start Time must be later than now";
        } else {
            return true;
        }
    },
    weekendRateRangeValidate(value) {
        console.log("validation weekend range",value);
        if (value) {
            if (!value.weekendMinRate) {
                return "Please input Min. Pay Rate";
            } else if (!value.weekendMaxRate) {
                return "Please input Max. Pay Rate";
            } else if (
                parseFloat(value.weekendMaxRate) == 0 ||
                parseFloat(value.weekendMinRate) == 0
            ) {
                return "Min and Max Rate must be higher than 0";
            } else if (
                parseFloat(value.weekendMinRate) > parseFloat(value.weekendMaxRate)
            ) {
                return "Max Rate must be higher than or equal to Min Rate";
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
    saturdayRateRangeValidate(value) {
        if (value) {
            if (!value.saturdayMinRate) {
                return "Please input Min. Pay Rate";
            } else if (!value.saturdayMaxRate) {
                return "Please input Max. Pay Rate";
            } else if (
                parseFloat(value.saturdayMaxRate) == 0 ||
                parseFloat(value.saturdayMinRate) == 0
            ) {
                return "Min and Max Rate must be higher than 0";
            } else if (
                parseFloat(value.saturdayMinRate) > parseFloat(value.saturdayMaxRate)
            ) {
                return "Max Rate must be higher than or equal to Min Rate";
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
    sundayRateRangeValidate(value) {
        console.log("sunday weekend range",value);
        if (value) {
            if (!value.sundayMinRate) {
                return "Please input Min. Pay Rate";
            } else if (!value.sundayMaxRate) {
                return "Please input Max. Pay Rate";
            } else if (
                parseFloat(value.sundayMaxRate) == 0 ||
                parseFloat(value.sundayMinRate) == 0
            ) {
                return "Min and Max Rate must be higher than 0";
            } else if (
                parseFloat(value.sundayMinRate) > parseFloat(value.sundayMaxRate)
            ) {
                return "Max Rate must be higher than or equal to Min Rate";
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
    rateRangeValidate(value) {
        if (!value.minRate) {
            return "Please input Min. Pay Rate";
        } else if (!value.maxRate) {
            return "Please input Max. Pay Rate";
        } else if (
            parseFloat(value.minRate) == 0 ||
            parseFloat(value.maxRate) == 0
        ) {
            return "Min and Max Rate must be higher than 0";
        } else if (parseFloat(value.minRate) > parseFloat(value.maxRate)) {
            return "Max Rate must be higher than or equal to Min Rate";
        } else {
            return true;
        }
    },
    payRateValidate(value) {
        if (!value || value == null) {
            return "Please input Pay Rate";
        } else if (value <= 0) {
            return "Rate must be higher than 0";
        } else {
            return true;
        }
    },

    dateRangeValidate(value){
        console.log('Iclicked');
        if (!value.from_date) {
            return "Please input From Date";
        } else if (!value.to_date) {
            return "Please input To Date";
        } else if (value.from_date && value.to_date && value.from_date <= value.to_date) {
            return "To date must be higher than From date";
        } else {
            return true;
        }
    },

    jobFiltersDaysValidate(value) {
        const isFalse = !Object.values(value).some((x) => x !== false);
        if (isFalse) {
            return "Please select at least one day";
        } else {
            return true;
        }
    },

    minRateValidate(value) {
        let minRate = value ? value.minRate || value : null;
        if (!minRate || minRate == null) {
            return "Please input Rate";
        } else if (minRate <= 0) {
            return "Rate must be higher than 0";
        } else {
            return true;
        }
    },

    weekendRateValidate(value) {
        console.log("🚀 ~ file: validate.js:691 ~ weekendRateValidate ~ value:", value)
        let weekendMinRate = value ? value.weekendMinRate || value : null;
        if (weekendMinRate !== null && weekendMinRate <= 0) {
            return "Rate must be higher than 0";
        } else if(value === null){
            return "Please input Weekend Rate";
        }else if(!value){
            return "Please input Weekend Rate";
        }
        else {
            return true;
        }
    },

    weekendSaturdayRateValidate(value) {
        console.log("saturday", value)
        let weekendMinRate = value ? value.saturdayMinRate || value : null;
        if (weekendMinRate !== null && weekendMinRate <= 0) {
            return "Rate must be higher than 0";
        } else {
            return true;
        }
    },
    weekendSundayRateValidate(value) {
        console.log("sunday", value)
        let weekendMinRate = value ? value.sundayMinRate || value : null;
        if (weekendMinRate !== null && weekendMinRate <= 0) {
            return "Rate must be higher than 0";
        } else {
            return true;
        }
    },
    maxRateValidate(value) {
        let maxRate = value.maxRate || value;
        if (!maxRate) {
            return "Please input Rate";
        } else {
            return true;
        }
    },

    jobShiftsBookValidate(value) {
        const isFalse = !value.some((x) => x.checkboxValue !== false);
        if (isFalse) {
            return "Please select at least one day";
        } else {
            return true;
        }
    },

    scheduleValidate(value) {
        const isFalse = !Object.values(value).some((x) => x !== false);
        if (isFalse) {
            return "Please select at least one day";
        } else {
            return true;
        }
    },

    environmentScriptsPerDayValidate(value) {
        if (!value) {
            return "Please select Average scripts per day";
        } else {
            return true;
        }
    },
    scriptsSaturdayValidate(value) {
        if (!value) {
            return "Please select Average scripts on Saturday";
        } else {
            return true;
        }
    },
    scriptsSundayValidate(value) {
        if (!value) {
            return "Please select Average scripts on Sunday";
        } else {
            return true;
        }
    },
    numberOfPatientsValidate(value) {
        if(value && value < 0) {
            return "The number of patients must be greater than or equal 0";
        }
        return true
    },
    environmentSoftwareValidate(value) {
        console.log("🚀 ~ environmentSoftwareValidate ~ value:", value)
        if (!value) {
            return "Please select Dispensing Software";
        } else {
            return true;
        }
    },
    environmentServicesValidate(value) {
        if (!value.length) {
            return "Please select at least one Service";
        } else {
            return true;
        }
    },

    supportMessageValidate(value) {
        if (!value) {
            return "Please share your issue with us";
        } else {
            
        // Trim the value to remove leading and trailing spaces
        const trimmedValue = value.trim();

            if (!trimmedValue) {
                return "Please share your issue with us";
            } else {
                // Split the trimmed value into words
                const words = trimmedValue.split(/\s+/);

                // Check if the number of words is not equal to 3
                if (words.length <= 3) {
                    return "A message must be more then 3 words";
                }

                // Check if the value is not just spaces
                if (!trimmedValue.replace(/\s/g, '').length) {
                    return "Value must not be just spaces";
                }

                // If all checks pass, return true
                return true;
            }
        }
    },

    chatMessageValidate(value) {
        if (!value) {
            return false;
        } else {
            return true;
        }
    },

    ratingStarsValidate(value) {
        if (!value) {
            return false;
        } else {
            return true;
        }
    },
    languagesValidate(value) {
        if (!value.length || value[0] == null) {
            return "Please select at least one Language";
        } else {
            return true;
        }
    },
    galleryValidate(value) {
        if (!value.length) {
            
            return "Please select at least one file";
        } else {
            return true;
        }
    },
    
    numOfTechValidate(value) {
        if (value < 0) {
            return "The value cannot be less than 0"
        } else {
            return true
        }
    },
    shopNumberValidate() {
        return true
    },
    gstValidate(value) {
        if (value) {
            return true
        } else {
            return true
        }
    },
    documentTypeValidate(){
        return true
    },
    visibilityStatusValidate(value) {
        if (!value.length || value[0] == null) {
            return "Please select at least one Language";
        } else {
            return true;
        }
    },
    agencyNoteValidate(value) {
        if (!value) {
            return "Please input notes";
        } else {
            return true;
        }
    },
    agencyRateValidate(value) {
        if(!value) {
            return "Please input fee";
        } else{
            return true;
        } 
         
    },
    eligibleToWorkInUsaValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    requireSponsorshipValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    socialSecurityNumberValidate(value, options, formField) {
        if (value == null) {
            return "Please input confirm code";
        } else if (value.length < formField.numberLength) {
            return "Please input all numbers";
        } else {
            return true;
        }
    },
    hasCorporationValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    taxPaymentTypeValidate(value) {
        if (value === null) {
            return "Please select Tax Payment Type";
        } else {
            return true;
        }
    },
    identificationNumberValidate(value) {
        const cleanValue = value.replace(/\D/g, '')
        if (!/^\d{10}$/.test(cleanValue)) {
            return 'Please enter a valid ten-digit number';
        } else if (!cleanValue) {
            return "Please input Identification Number";
        } else {
            return true;
        }
    },
    corporationNameValidate(value) {
        if (!value) {
            return "Please input Corporation Name";
        } else {
            return true;
        }
    },
    recordCorporationDetailsValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    existingHealthPlanValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    optInHealthPlanValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    preTaxPercentage401kValidate(value) {
        if (/^(?!0\.00$)(0\.(?!0+$)\d+|[1-4]?\d(\.\d+)?|50(\.0+)?)$/.test(value)) {
            return true;
        } else {
            return "The amount cannot be less or equal to 0";
        }
    },
    has401kValidate(value) {
        if (value === null || value === "") {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    yesNoValidate(value) {
        if (value === null || value === "" || value === undefined) {
            return "Please select Yes or No";
        } else {
            return true;
        }
    },
    pharmacyTypeValidate(value) {
        if (value === null) {
            return "Please select Pharmacy Type";
        } else {
            return true;
        }
    },
    hasRoboticDispensingSystemValidate() {
        return true
    },
    alwaysTrueValidate() {
        return true
    }
};
